import { useQuery } from "@tanstack/react-query";
import type { CostCenter } from "../models/CostCenter";
import { getCostCenters } from "../repositories/CostCentersRepository";

export const COST_CENTERS_QUERY_KEYS = {
	all: ["costCenters"] as const,
	list: () => ["costCenters", "list"] as const,
	byId: (id: number | null) => ["costCenters", "detail", id] as const,
};

export const useCostCenters = () => {
	const query = useQuery<CostCenter[], Error>({
		queryKey: COST_CENTERS_QUERY_KEYS.list(),
		queryFn: () => getCostCenters(),
	});

	return {
		costCenters: query.data ?? [],
		isLoading: query.isLoading,
		error: query.error,
		refetch: query.refetch,
	};
};
